// The own check-in alarm snapshot (architecture sprint-14 §8.2). Never fetched on its own: GET /api/timer
// (30 s polling, hidden tabs too) carries it and useTimer writes it here, as do the heartbeat and confirm
// responses. `receivedAt` pairs with `alarm.serverNow` for the projected clock.
import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { AlarmStateDto, CheckinSlotDto } from '@shared/alarm-rules';
import { apiRequest } from '@/lib/api';
import type { AlarmSnapshot } from '@/lib/alarm-model';

export const ALARM_KEY = ['alarm'] as const;

export function setAlarmSnapshot(queryClient: QueryClient, alarm: AlarmStateDto | null): void {
  const snapshot: AlarmSnapshot = { alarm, receivedAt: performance.now() };
  queryClient.setQueryData(ALARM_KEY, snapshot);
}

export function useAlarm(): AlarmSnapshot | undefined {
  const { data } = useQuery<AlarmSnapshot>({
    queryKey: ALARM_KEY,
    queryFn: () => Promise.reject(new Error('the alarm state is loaded with GET /api/timer')),
    enabled: false,
    staleTime: Infinity,
  });
  return data;
}

export interface HeartbeatBody {
  visible: boolean;
  armed: boolean;
  device: 'laptop' | 'phone';
}

export function postHeartbeat(body: HeartbeatBody): Promise<{ alarm: AlarmStateDto | null }> {
  return apiRequest<{ alarm: AlarmStateDto | null }>('/api/alarms/heartbeat', { method: 'POST', body: JSON.stringify(body) });
}

export function postConfirm(rang: Array<{ scheduledAt: string; rangAt: string }>): Promise<{ confirmed: CheckinSlotDto[]; alarm: AlarmStateDto | null }> {
  return apiRequest<{ confirmed: CheckinSlotDto[]; alarm: AlarmStateDto | null }>('/api/alarms/confirm', {
    method: 'POST',
    body: JSON.stringify(rang.length > 0 ? { rang } : {}),
  });
}
